import { showSuccess, showError } from '@/utils/toastHelpers';
import { useCreateRace, useUpdateRace, useDeleteRace } from '@/hooks/useRaces';
import { useEntityActions } from '@/hooks/useEntityActions';
import { transformEventToRace } from '@/utils/transforms';
import { EventFormData, EventItem } from './eventsmanager.props';

const emptyForm = (organizerId = ''): EventFormData => ({
  title: '', subtitle: '', location: '', organizerId,
  raceSeriesId: '', date: '', time: '', image: '',
  status: 'upcoming', openRegistrationDate: '', closeRegistrationDate: '', description: '',
});

export const useEventsActions = (isOrganizer: () => boolean, user: any) => {
  const createRace = useCreateRace();
  const updateRace = useUpdateRace();
  const deleteRace = useDeleteRace();

  const crud = useEntityActions<EventItem, EventFormData>({
    emptyForm: () => emptyForm(isOrganizer() ? (user?.organizerId || '') : ''),
    deleteMutation: deleteRace,
    entityName: 'Настанот',
  });

  const handleEdit = (event: EventItem) => {
    crud.openEdit(event, (e) => ({
      title: e.title, subtitle: e.subtitle || '', location: e.location,
      organizerId: e.organizerId, raceSeriesId: e.raceSeriesId || '',
      date: e.date, time: e.time, image: e.image, status: e.status,
      openRegistrationDate: e.openRegistrationDate || '',
      closeRegistrationDate: e.closeRegistrationDate || '',
      description: e.description || '',
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const raceData = transformEventToRace(crud.formData);
      if (crud.editingEntity) {
        await updateRace.mutateAsync({ id: crud.editingEntity.id, data: raceData });
        showSuccess('Успешно ажурирано', 'Настанот е успешно ажуриран.');
      } else {
        await createRace.mutateAsync(raceData);
        showSuccess('Успешно креирано', 'Нов настан е успешно креиран.');
      }
      crud.resetDialog();
    } catch (error) {
      showError(error, 'настанот');
    }
  };

  return {
    isDialogOpen: crud.isDialogOpen, setIsDialogOpen: crud.setIsDialogOpen,
    editingEvent: crud.editingEntity, setEditingEvent: crud.setEditingEntity,
    deleteTarget: crud.deleteTarget, setDeleteTarget: crud.setDeleteTarget,
    formData: crud.formData, setFormData: crud.setFormData,
    handleEdit, handleDelete: crud.handleDelete, confirmDelete: crud.confirmDelete, handleSubmit,
  };
};
